import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ngx-cm-activity-indicator',
  templateUrl: './ngx-cm-activity-indicator.component.html',
  styleUrls: ['./ngx-cm-activity-indicator.component.scss']
})
export class NgxCmActivityIndicatorComponent implements OnInit {
  @Input()
  Label;

  constructor() { }

  ngOnInit() {
  }

}
